import React from 'react';
import { Menu } from 'antd';
import "./game-style.css";
import createMenuPng from './images/createMenu.png';
import homemenuPng from './images/homemenu.png';
import settingmenuPng from './images/settingmenu.png';

function MenuLayout({ onCreate = () => null }) {
  return (
    <div className='listMenuText'>
      <Menu className='listMenuText'>
        <Menu.Item key="key1">
          <a href="#" onClick={() => onCreate()}><img src={createMenuPng} alt="" /><span>Create</span></a>
        </Menu.Item>
        <Menu.Item key="key2">
          <a href="#"><img src={homemenuPng} alt="" /><span>Home</span></a>
        </Menu.Item>
        <Menu.Item key="key3">
          <a href="#"><img src={settingmenuPng} alt="" /><span>Settings</span></a>
        </Menu.Item>
      </Menu>
    </div>
  );
}

export default MenuLayout;